import { types as api } from '@mesa-labs/mesa-api';
import React from 'react';
import styled from 'styled-components';

import {
  ActionItemStaleAge, ActionItemStaleness, actionItemStalenessTitle, ActionItemStalenessColors, formatActionItemIdleAge,
} from '../../../../utils/vendorActionItems';

const Age = styled.span<{ $staleness: ActionItemStaleness }>`
  color: ${(p) => ActionItemStalenessColors[p.$staleness].text};
  font-weight: 600;
`;


// A stale item's idle age ("5d") in amber or red; nothing for a fresh or closed item. `stale` is the item's
// actionItemStaleAge, which the caller already has for its own styling.
export default function StaleAge({ item, stale }: {
  item: api.VendorActionItemResponse;
  stale?: ActionItemStaleAge;
}): React.ReactElement | null {
  if (!stale) return null;
  return <Age $staleness={stale.staleness} title={actionItemStalenessTitle(stale)}>{formatActionItemIdleAge(item)}</Age>;
}
